module.exports = __webpack_public_path__ + "fonts/c802479dd7a523a4223585822e683047.svg";